import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const SetColorContainer = styled.div`
  width: 360px;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-left: 40px;
`;

export const PickColorText = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.shade01};
  margin: 0;
`;

export const ColorsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 60px;
  align-items: center;
`;

export const ColorButton = styled.button`
  width: ${({ active }) => (active ? 60 : 40)}px;
  height: ${({ active }) => (active ? 60 : 40)}px;
  border-radius: ${({ active }) => (active ? 60 : 40)}px;
  cursor: pointer;
  border: ${({ active }) => (active ? `4px solid ${Colors.shade08}` : 'none')};
  box-sizing: border-box;
  box-shadow: ${({ active }) => (active ? '0 2px 24px rgba(45, 49, 50, 0.25)' : '0 2px 10px rgba(45, 49, 50, 0.08)')};
`;

export const IconU = styled.i`
  font-size: 140px;
`;

export const ResultSetContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 160px;
  background: ${Colors.shade08};
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.08);
  border-radius: 8px;
`;

export const ColorPickerContainer = styled.div`
  margin-top: 10px;
  padding: 32px 46px 32px 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: ${Colors.shade07};
  border-radius: 8px;
`;
